module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "clustering-gql.worker.83ee37dd2fa3740f584b.worker.js");
}
